import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** FID-MESH-01 — readable shadow-shuriken silhouette marker. */
export const ZED_SILHOUETTE_MARKER = Object.freeze({
  id: 'zed_shuriken',
  radius: 0.32,
  thickness: 0.08,
  radialSegments: 4,
  blueColor: 0x818cf8,
  redColor: 0xe879f9
});

/** Zed mesh — shadow ninja silhouette. */
export function createZedMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x64748b : 0xf87171;
  const markerHex = team === 'blue'
    ? ZED_SILHOUETTE_MARKER.blueColor
    : ZED_SILHOUETTE_MARKER.redColor;
  const bodyMat = new MeshStandardMaterial({ color: 0x0f172a, roughness: 0.5 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.35, metalness: 0.35 });
  const markerMat = new MeshStandardMaterial({
    color: markerHex,
    roughness: 0.25,
    metalness: 0.55
  });
  const body = new Mesh(new ConeGeometry(0.52, 1.95, 10), bodyMat);
  body.position.y = 1.15;
  group.add(body);
  const hood = new Mesh(new SphereGeometry(0.36, 12, 12), trimMat);
  hood.position.y = 2.35;
  group.add(hood);
  const { radius, thickness, radialSegments, id } = ZED_SILHOUETTE_MARKER;
  const shuriken = new Mesh(
    new CylinderGeometry(radius, radius, thickness, radialSegments),
    markerMat
  );
  shuriken.rotation.x = Math.PI / 2;
  shuriken.position.set(0.72, 1.55, 0.22);
  shuriken.userData.silhouetteMarker = id;
  group.add(shuriken);
  return group;
}
